import { sha1 } from 'js-sha1';

// Public LD evaluation salt, pinned to the reviewed Production configuration.
// This is cohort compatibility, not a security or cryptographic operation.
const PAYMENT_ERROR_BUCKET_PREFIX =
  'enable-payment-error-continue.6806af33a2764540ab7e3b143075bebb.';
export const PAYMENT_ERROR_COHORT_ATTRIBUTE = '__ld_cohort__enable_payment_error_continue';

/** Preserve LD's user/key 50% cohort while Datadog serves the flag. */
export const legacyPaymentErrorCohort = (key: string): 'true' | 'false' => {
  const bucket =
    parseInt(sha1(PAYMENT_ERROR_BUCKET_PREFIX + key).slice(0, 15), 16) / 0xfffffffffffffff;
  return bucket < 0.5 ? 'true' : 'false';
};
